var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v("Manifiestos"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-sm text-muted mb-0" }, [
                    _vm._v("Mostrando Manifiesto - " + _vm._s(_vm.data.awb)),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid vstack gap-5" },
          [
            _vm.data.packages.length == 0 &&
            _vm.data.hawbs.length == 0 &&
            !_vm.loading
              ? _c("div", [
                  _c(
                    "p",
                    { staticClass: "text-sm text-muted text-center mb-0" },
                    [_vm._v("No hay resultados.")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.packages.length > 0
              ? _c("v-table", {
                  attrs: {
                    data: _vm.data.packages,
                    title: _vm.data.awb,
                    is_open: _vm.data.state_id == 19,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.data.hawbs, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("v-table", {
                    attrs: {
                      data: item.packages,
                      title: item.hawb,
                      is_open:
                        _vm.data.state_id == 19 &&
                        _vm.globalViewOption("AwbRemovePackage"),
                    },
                  }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.loading
              ? _c("div", { staticClass: "w-100 pt-5" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }